import { Components, Theme } from '@mui/material/styles';

export default function MuiDialog(theme: Theme): Components['MuiDialog'] {
  return {
    styleOverrides: {
      root: {
        '& div[role="dialog"] > :last-child': {
          paddingBottom: '56px',
        },
        '& div[role="dialog"]': {
          backgroundColor: theme.palette.sand.main,
        },
      },
    },
  };
}
